import { Component } from '../lib/ComponentBase';
import { simpleComponent } from '../lib/ComponentHelpers';
import type { DataComponent } from '../types/Components';

/**
 * A component that assigns an entity to a faction.
 * Used to determine relationships like hostility.
 */
class Faction extends Component implements DataComponent {
  name: string;

  constructor(data: { name?: string } = {}) {
    super();
    this.name = data.name ?? '';
  }
}

export default simpleComponent(Faction);
